// Packages
import { Component } from "react";
import { Link, Redirect } from "react-router-dom";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";

// Styles
import "./superAdmin.css";

import "bootstrap/dist/css/bootstrap.css";

// Material Ui
import AddIcon from "@material-ui/icons/Add";
import { CircularProgress, Paper } from "@material-ui/core";
// Services
import userService from "../../services/user.service";
import ErrorMessage from "../../Common/ErrorMessage";
import { DataGrid } from "@mui/x-data-grid";
import CustomSearch from "../../Common/CustomSearch";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

class Payment extends Component {
  constructor() {
    super();
    this.state = {
      billingDetailsResponses: [],
      submitting: false,
      blure: false,
      search: false,
      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      recordNotFound: false,
      searchQuery: "",
      btnText: "",
      successPopup: false,
      msg: "",
      redirectToRow: false,
      currentRowId: "",
      searchedRecord: false,
      loginRole: getFromLocalStorage("loginRole"),
    };
  }

  componentDidMount() {
    const payment = document.getElementById("Payments");
    const { pageState } = this.state;
    if (payment) {
      payment.classList.add("active");
    }
    this.setState({ submitting: true });
    this.getBillingDetailsByPage(pageState.page, pageState.pageSize);
  }

  getBillingDetailsByPage = (page, size) => {
    const { schoolId, recordNotFound, pageState } = this.state;
    this.setState({
      pageState: { ...pageState, isLoading: true },
    });
    userService
      .getAllBillingListing(page, size)
      .then((res) => {
        const data = res.data.data;
        this.setState({
          pageState: {
            ...pageState,
            data: data.billingDetailsResponses,
            isLoading: false,
            total: data.total,
            page: page,
          },
          submitting: false,
        });
        if (recordNotFound) {
          this.setRecordNotFound();
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: { ...pageState, isLoading: true },
          submitting: false,
        });
      });
  };

  searchPayment = (query, page, size) => {
    const { schoolId, searchedRecord } = this.state;
    this.setState({
      pageState: { ...this.state.pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchPaymentHistory(query, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.billingDetailsResponses,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          recordNotFound:
            res.data.data.billingDetailsResponses.length == 0 ? true : false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  render() {
    const {
      billingDetailsResponses,
      search,
      submitting,
      pageState,
      searchQuery,
      redirectToRow,
      currentRowId,
      searchedRecord,
      recordNotFound,
      loginRole,
    } = this.state;

    const tableColumns = [
      {
        field: "school.schoolName",
        headerName: "School",
        headerAlign: "center",
        headerClassName: "table-header bold",
        width: 200,
        cellClassName: "custom-cell",
        renderCell: (params) => (
          <div className="d-flex-align-cent height-70 w-100 padding-left-10 padding-right-10">
            <p className="link-blue text-width-auto mg-auto">
              {params.row.schoolName}
            </p>
          </div>
        ),
      },
      {
        field: "invoiceCount",
        headerName: "Invoice",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 150,
        align: "center",
      },
      {
        field: "paidCount",
        headerName: "Paid",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 150,
        align: "center",
      },
      {
        field: "pendingCount",
        headerName: "Pending",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 150,
        align: "center",
      },
      {
        field: "overDueCount",
        headerName: "OverDue",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 150,
        align: "center",
      },
    ];

    if (redirectToRow) {
      return <Redirect to={`/paymentSchoolDetails/${currentRowId}`} />;
    }
    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div>
            <div className="content-layout pt-20">
              <SuperAdminDashboard />
              <div className="mng-header stickyy">
                <h4 className="fs-24 bold mob-hd">PAYMENTS</h4>
                <Link className="" to="/EditPaymentBill">
                  <button className="addBtnn2 mng-padding">
                    <AddIcon className="mx-1 addIconSc " />
                    Add New Payment
                  </button>
                </Link>
              </div>

              {submitting && (
                <div className="content-layout-loading-animation">
                  <CircularProgress sx={{ fontSize: 10, color: "#002244" }} />
                </div>
              )}
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr ">
                {!submitting &&
                  !pageState.data.length > 0 &&
                  !recordNotFound && <ErrorMessage />}

                {!submitting &&
                  (pageState.data.length > 0 || recordNotFound) && (
                    <Paper className="pad-top-20 mg-bottom-20">
                      <CustomSearch
                        searchQuery={searchQuery}
                        setSearchQuery={this.setSearchQuery}
                        setSearchedRecord={this.setSearchedRecord}
                        searchedRecord={searchedRecord}
                        getDataByPage={this.getBillingDetailsByPage}
                        pageState={pageState}
                        searchData={this.searchPayment}
                        setRecordNotFound={this.setRecordNotFound}
                      />
                      <DataGrid
                        rows={pageState.data}
                        rowCount={pageState.total}
                        loading={pageState.isLoading}
                        pagination
                        page={pageState.page}
                        columns={tableColumns}
                        pageSize={pageState.pageSize}
                        rowsPerPageOptions={[10]}
                        paginationMode="server"
                        onPageChange={(newPage) => {
                          if (searchQuery == "") {
                            this.getBillingDetailsByPage(newPage, 10);
                          } else {
                            this.searchPayment(searchQuery, newPage, 10);
                          }
                          this.setState({ ...pageState, page: newPage });
                        }}
                        onPageSizeChange={(newPageSize) =>
                          this.setState({
                            ...pageState,
                            pageSize: newPageSize,
                          })
                        }
                        sx={{
                          color: "black",
                          fontFamily: "Rajdhani-SemiBold",
                          fontSize: "18px",
                          backgroundColor: "white",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        onCellClick={(param) => {
                          this.setState({
                            redirectToRow: true,
                            currentRowId: param.row.schoolId,
                          });
                        }}
                        autoHeight
                        disableColumnMenu
                        getRowHeight={() => "auto"}
                        getRowId={(row) => row.schoolName}
                        disableSelectionOnClick
                      />
                    </Paper>
                  )}
              </div>
            </div>
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

export default Payment;
